import React from "react";
// @material-ui/core components
import { makeStyles, Typography, Button, Accordion, AccordionSummary, AccordionDetails } from "@material-ui/core";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import { whiteColor, grayColor, hexToRgb } from "assets/jss/material-dashboard-react.js";

const useStyles = makeStyles((theme) => ({
  accordions: {
    width: '100%',
    paddingTop: 20,
    paddingBottom: 20,
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(" + hexToRgb(whiteColor) + ",.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    "& a,& a:hover,& a:focus": {
      color: whiteColor
    }
  },
  cardTitleWhite: {
    color: whiteColor,
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: grayColor[1],
      fontWeight: "400",
      lineHeight: "1"
    }
  },
  question: {
    fontSize: 20,
    textAlign: 'justify',
  },
  answer: {
    margin: 6,
    textAlign: 'justify',
  },
  whatsappBtn:{
    color: 'white',
    fontWeight: 500,
    background: 'rgb(70, 170, 120)',
    padding: 10,
    margin: 20,
    '&:hover':{
      background: 'rgb(80, 180, 130)',
      color: 'white',
      boxShadow: '3px 3px 10px gray'
    },
  },
  WhatsAppIcon: {
    marginRight: 10,
  },
  contact:{
    marginLeft: 10,
  },
  summary:{
    background: 'rgb(250, 250, 250)'
  },
  accordion:{
    margin: 8,
  }
}));


export default function Help() {
  const classes = useStyles();
  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader plain color="primary">
            <h4 className={classes.cardTitleWhite}>Tire aqui suas dúvidas</h4>
            <p className={classes.cardCategoryWhite}>
              Leia nossa F.A.Q. com as perguntas mais frequentes antes de mandar sua dúvida.
            </p>
          </CardHeader>
          <CardBody>
          <div className={classes.accordions}>
            <Accordion className={classes.accordion}>
              <AccordionSummary className={classes.summary}
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography className={classes.heading}>
                  • O que é <b>avalicaopreanestesica.com</b>?
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  - Avaliação Pré-Anestésica.com é um aplicativo web para realização de
                  consultas pré-anestésicas. Pode ser acessado de qualquer dispositivo
                  com acesso a internet. É simples, rápido e completo.
                </Typography>
              </AccordionDetails>
            </Accordion>
            <Accordion className={classes.accordion}>
              <AccordionSummary className={classes.summary}
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography className={classes.heading}>
                  • Quais <b>navegadores</b> devo usar?
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  - Nos sistemas Windows e Android, utilize o navegador <b>Chrome</b>.
                  Nos sistemas Apple (iPhone e Mac) utilize o navegador <b>Safari</b>. O
                  sistema foi desenvolvido e testado nesses navegadores, portanto
                  funcionamento inadequado pode ocorrer nos demais.
                </Typography>
              </AccordionDetails>
            </Accordion>
            <Accordion className={classes.accordion}>
              <AccordionSummary className={classes.summary}
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography className={classes.heading}>
                  • Como usar?
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  - É só clicar em <b>“Nova Apa”</b> - no menu lateral - e realizar sua
                  consulta. Após salvar, as fichas estarão disponíveis em <b>“Fichas
                  Atendidas”</b>. Nesta seção, basta clicar no ícone “Opções” para ter
                  acesso às facilidades (Baixar, Imprimir, Termo de Consentimento,
                    Escores de Risco)
                </Typography>
              </AccordionDetails>
            </Accordion>
            <Accordion className={classes.accordion}>
              <AccordionSummary className={classes.summary}
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography className={classes.heading}>
                  • E em relação a <b>grupos</b>. Como o sistema funciona ?
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  - Na seção “Grupos”, todos os membros do grupo podem ter acesso
                  as fichas atendidas pelos demais. Entre em contato conosco para
                  mais detalhes.
                </Typography>
              </AccordionDetails>
            </Accordion>
            <Accordion className={classes.accordion}>
              <AccordionSummary className={classes.summary}
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography className={classes.heading}>
                • Para que preciso preencher o meu <b>Perfil</b>?
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                - Alguns dados do perfil são automaticamente colocados no PDF da
                ficha de Anestesia, Termo de Consentimento e Previsão Orçamentária.<br/>
                Entre esses dados usados estão: nome de exibição (ex: Dr. José Santos),
                CRM, cidade e estado.
                É importante preencher todos os campos com atenção, pois as informações
                fornecidas só poderão ser atualizadas após 30 dias.
                </Typography>
              </AccordionDetails>
            </Accordion>
            <Accordion className={classes.accordion}>
              <AccordionSummary className={classes.summary}
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography className={classes.heading}>
                • Para que servem as <b>Opções de Preenchimento</b> no menu Opções?
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                - É lá que você escolhe o que será preenchido automaticamente nos
                respectivos campos da ficha de anestesia.<br/>
                Desse modo, quando o paciente negar alergias, você pode preferir
                que esse campo seja preenchido da forma que julgar mais conveniente,
                exemplos: "Nega Alergias", "Desconhece Alergias", "-", "Ø" ou até
                mesmo deixar em branco.<br/>
                <br/>
                Os últimos campos são as <b>Prescrições Padrões</b>. Salve até 5 prescrições
                para economizar tempo e não precisar digitar repetidamente na ficha de APA.<br/>
                </Typography>
              </AccordionDetails>
            </Accordion>
            <Accordion className={classes.accordion}>
              <AccordionSummary className={classes.summary}
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography className={classes.heading}>
                    • Como imprimir o <b>Termo de Consentimento</b>?
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                - No menu lateral, clique em <b>Fichas Atendidas</b>. Ao lado do nome de
                cada paciente tem 2 ícones, quais sejam: 1) Editar - para mudar qualquer
                informação previamente preenchida. 2) <b>Opções</b> - para abrir diversas opções
                como: 'Imprimir', 'Termo de Consentimento', 'Orçamento' e 'Delete'.
                </Typography>
              </AccordionDetails>
            </Accordion>
            <Accordion className={classes.accordion}>
              <AccordionSummary className={classes.summary}
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography className={classes.heading}>
                    • Onde <b>encontro</b> a opção de fazer <b>Orçamento</b>?
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                - No menu lateral, clique em <b>Fichas Atendidas</b>. Ao lado do nome de
                cada paciente tem 2 ícones, clique no último <b>ícone 'Opções'</b> que é o com
                3 pontinhos. Um menu abrirá com diversas opções, como 'imprimir',
                <b>'ORÇAR'</b>, 'TCLE' e 'apagar ficha'.
                </Typography>
              </AccordionDetails>
            </Accordion>
            <Accordion className={classes.accordion}>
              <AccordionSummary className={classes.summary}
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography className={classes.heading}>
                • Como <b>fazer o Orçamento</b>?
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                - Existem basicamente <b>duas formas</b> de fazer o orçamento:<br/>
                  1) A forma <b>mais simples</b> é apenas colocar os valores ao lado
                  de cada procedimento e clicar em salvar. Para essa método, preencher
                  portes e vias de cada procedimento é opcional. Importante lembrar
                  que, para discriminar mais de um procedimento, é necessário deixar
                  apenas um por linha na ficha de A.P.A.<br/>
                  2) A segunda forma é um pouco mais elaborada, porém <b>recomendada</b> para
                  quem pretende utilizar a ferramenta de Orçamento com alguma frequência.
                  Cadastre uma tabela (ou mais de uma) com os valores que deseja usar, essa
                  tabela ficará salva para uso futuro. Selecione a tabela desejada.
                  Em seguida, basta preencher portes e vias de cada procedimento.
                  Opcionalmente, é possivel selecionar a opção para dobrar os
                  valores ou adicionar 30%.<br/>
                  Depois de salvos, os orçamentos estão disponíveis para impressão
                  em <b>PDF ORÇAMENTO</b>, localizado no mesmo menu da opção <b>ORÇAR</b>.
                </Typography>
              </AccordionDetails>
            </Accordion>
            <Accordion className={classes.accordion}>
              <AccordionSummary className={classes.summary}
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography className={classes.heading}>
                • Ao assinar o <b>Plano PRO</b>, ao que tenho direito?
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                - Uso irrestrito de todas as ferramentas. Quantidade ilimitada de
                atendimentos. Ficha de Anestesia, Termo de Consentimento e Previsão
                Orçamentária Personalizados.<br/>
                Em breve, novas funcionalidades serão implementadas e todas estarão
                incluídas no Plano Pro.
                </Typography>
              </AccordionDetails>
            </Accordion>
            <Accordion className={classes.accordion}>
              <AccordionSummary className={classes.summary}
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography className={classes.heading}>
                • Posso fazer o <b>cancelamento</b> da minha assinatura a qualquer momento?
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                - Sim. Basta clicar em "Gerenciar Assinatura" no menu Perfil.
                Ao cancelar o plano, seu cartão de crédito não será mais cobrado,
                mas você ainda poderá usufruir do plano PRO até o fim do período atual de faturamento.
                </Typography>
              </AccordionDetails>
            </Accordion>
          </div>
          <br/>
          <div className={classes.contact}>
            <Typography>Não conseguiu esclarecer suas dúvidas? Entre em contato com nossa equipe:</Typography>
            <br/>
            <Button className={classes.whatsappBtn} href="https://wa.me/5579998522626?text=Tenho%20uma%20dúvida%20referente%20ao%20site">
              <WhatsAppIcon className={classes.WhatsAppIcon}/> FALE CONOSCO
            </Button>
          </div>
          <br/>
          <br/>
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}
